import React, { FC, memo, PropsWithChildren, useContext } from 'react';

import { ChunkedImageProperties } from '../types/chunkedImage';

export type ImageTypeOverviewChunks = Record<
	number,
	{ cropped: ChunkedImageProperties[] | undefined; uncropped: ChunkedImageProperties[] | undefined }
>;

export interface OverviewLoaderContextProps {
	chunks: ImageTypeOverviewChunks;
	resolutions: Record<number, number | undefined>;
}

const OverviewChunksContext = React.createContext<OverviewLoaderContextProps>({
	chunks: {},
	resolutions: {},
});
export { OverviewChunksContext };

const OverviewChunksProviderInternal: FC<PropsWithChildren<{ value: OverviewLoaderContextProps }>> = ({
	value,
	children,
}) => {
	return <OverviewChunksContext.Provider value={value}>{children}</OverviewChunksContext.Provider>;
};

/**
 * Value-only provider for overview chunks. The actual loading lives in CVSL — consumers
 * compute the chunks via CVSL's `useOverviewChunks` (or wrap with CVSL's `<OverviewLoaderProvider>`)
 * and pass the resulting state in here.
 */
export const OverviewLoaderProvider = memo(OverviewChunksProviderInternal);

// eslint-disable-next-line react-refresh/only-export-components
export const useOverviewChunksContext = (): OverviewLoaderContextProps => {
	return useContext(OverviewChunksContext);
};
